<template>
  <div>
    <v-btn color="primary" dark @click.stop="drawer = !drawer">MENU <v-icon dark right>fas fa-bars</v-icon></v-btn>
    <v-navigation-drawer absolute temporary v-model="drawer" app>
      <v-list dense>
        <v-list-item v-for="(item, i) in items" :key="i" exact :to="item.page">
          <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click.native="logout">
          <v-list-item-content>
            <v-list-item-title>Sair</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <notifications position="bottom center" />
  </div>
</template>

<script>
//import Vue from 'vue'
export default {
  data() {
    return {
      drawer: false,
      items: [],
      title: "MENU"
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.items = [
        {
          icon: "",
          title: "Início",
          page: "/home"
        },
        {
          icon: "",
          title: "Meu Plano",
          page: "/plan"
        },
        {
          icon: "",
          title: "Chat",
          page: "/chat"
        },
        {
          icon: "",
          title: "Minha Conta",
          page: "/account"
        },
        {
          icon: "",
          title: "Notificações",
          page: "/notifications"
        },
        {
          icon: "",
          title: "Sobre",
          page: "/page/Sobre"
        },
        {
          icon: "",
          title: "Termos de Uso",
          page: "/page/Termos"
        },
        {
          title: "Politica de Privacidade",
          page: "/page/Politica de Privacidade"
        }
      ];
    },
    logout() {
      this.$auth.signOut().then(() => {
        window.location.href = "/login";
      });
    }
  }
};
</script>

